import React, { useState } from "react";

const InputGroup = ({ label, value, ...rest }) => {
	const [state, setState] = useState(value ? value : "");
	return (
		<>
			<label>
				<div className={`form-label ${state ? "form-filled" : ""}`}>
					{label}
				</div>
				<input
					type="text"
					className="form-control"
					value={state}
					onChange={(e) => setState(e.target.value)}
					{...rest}
				/>
			</label>
		</>
	);
};

export default InputGroup;
